import {Routes} from '@angular/router';
import { AuthGuard } from '@core/services/auth-guard.service';
import { CurrentProjectGuard } from '../../projects/services/current-project-guard';
import {TransactionImportComponent} from './components/transaction-import/transaction-import.component';
import {TransactionToolbarComponent} from './components/transaction-toolbar/transaction-toolbar.component';
import {TransactionImportToolbarComponent} from './components/transaction-import/transaction-import-toolbar/transaction-import-toolbar.component';

import {TransactionContentComponent} from './components/transaction-content/transaction-content.component';

export const transactionRoutes: Routes = [
  {
    path: 'cr/settings/transactions',
        component: TransactionContentComponent,
    canActivate: [AuthGuard, CurrentProjectGuard]
  },
  {
    path: 'footprint/transactions',
    component: TransactionContentComponent,
    canActivate: [AuthGuard, CurrentProjectGuard]
  },
  {
    path: 'footprint/transactions/transactions-import',
    component: TransactionImportComponent,
    canActivate: [AuthGuard, CurrentProjectGuard]
  },
  {
    path: 'transactions-toolbar',
    component: TransactionToolbarComponent,
    outlet: 'top-toolbar',
    canActivate: [AuthGuard, CurrentProjectGuard]
  },
  {
    path: 'transaction-import-toolbar',
    component: TransactionImportToolbarComponent,
    outlet: 'top-toolbar',
    canActivate: [AuthGuard, CurrentProjectGuard]
  },
];
